import { SharedFooter } from '../shared/SharedFooter';

/**
 * Footer for the About page. Delegates to the shared footer.
 *
 * @returns The footer element.
 */
export function AboutFooter() {
  return <SharedFooter />;
}
